//HighlightGraphics.ts ==============================================================
import "../Util/Prototypes";

import * as DrawerMenu from "../Menus/DrawerMenu";
import * as GraLay from "../Util/GraLay";
import * as Highlight from "../Util/Highlight";
import * as HighlightGraphics from "../Util/HighlightGraphics";
import * as MainMap from "../MainMap";
import * as SelectOnMap from "../Search/SelectOnMap";
import * as Settings from "../Settings";
import * as Util_App from "../Util/Util_App";

export let overSelectedGraphic: boolean = false;

interface iHitLayer {
   layerName: string;
   objectId: number;
   handle: __esri.Handle;  // Reference to the highlighted feature.
   active: boolean; // True means feature is currently being highlighted.
}
const hitLayers: iHitLayer[] = []; // Array of layers containing highlighted features.

//Process mouse out of map view event.
export function init() {
   MainMap.activeView.on("pointer-leave", function () {
      setTimeout(function () { clearHitLayers(true); }, 200);
   });
}

//Highlight currently selected features when hovering over map graphics.
export function mapMouseMove(event: __esri.ViewPointerMoveEvent) {
   if (!MainMap.activeView.ready) {
      return; //Quit if not ready.
   }

   //Hit test checks to see if any graphics intersect the given screen x, y coordinates.
   if (DrawerMenu.curToolName === "Select on Map" || DrawerMenu.curToolName === "Search Results" || Settings.selectOnMapAlwaysActive || Settings.identifyEnabled) {
      const screenPoint = event as __esri.ScreenPoint;

      MainMap.activeView.hitTest(screenPoint).then(function (response: __esri.HitTestResult) {
         let graFound: boolean = false;
         overSelectedGraphic = false;
         GraLay.clearSelectHoverGraphics();

         for (const hitLayer of hitLayers) {
            hitLayer.active = false;
         }

         //Process each graphic layer.
         for (let result of response.results) {
            result = result as __esri.GraphicHit;

            const gra = result.graphic;
            if (!gra.layer) {
               continue; //Skip if layer not available.
            }

            const layerName: string = gra.layer.id;

            if (layerName.StartsWith("sketch")) {
               continue; //Skip if over a sketch.
            }

            //Highlight currently selected feature when hovering over map graphic.
            if (layerName.StartsWith("selected")) {
               overSelectedGraphic = true;

               if (!SelectOnMap.active) {
                  graFound = true;
                  MainMap.activeViewDiv.style.cursor = "pointer";
                  Util_App.highlightGraphic(gra);
               }

               //Highlight features when hovering over feature layer.
            } else if (gra.layer.type === "feature") {

               if (SelectOnMap.selectableLayer === layerName || SelectOnMap.selectableLayer === "All Visible Layers") {
                  if (Highlight.shouldBeHighlighted(gra, layerName)) {
                     graFound = true;
                     MainMap.activeViewDiv.style.cursor = "pointer";

                     MainMap.activeView.whenLayerView(gra.layer).then(function (layerView: __esri.FeatureLayerView) {
                        let objectId = 0;
                        if (gra.attributes.OBJECTID) {
                           objectId = gra.attributes.OBJECTID;
                        }
                        if (gra.attributes.objectid) {
                           objectId = gra.attributes.objectid;
                        }

                        const hitLayer: iHitLayer = getHitLayer(layerName);
                        if (hitLayer) {
                           hitLayer.active = true;       //Make it active.

                           //Util.logMsg("Existing OID & New OID HitLayers: " + layerName + " " + hitLayer.objectId + " " + objectId, hitLayers);

                           if (hitLayer.objectId !== objectId) {
                              if (hitLayer.handle) {
                                 hitLayer.handle.remove(); //Unhighlight existing feature.
                              }

                              hitLayer.handle = layerView.highlight(gra); //Highlight new feature and update reference to it.
                              hitLayer.objectId = objectId; //Update object id.
                              //Util.errMsg("Highlighted: " + hitLayer.objectId + " " + objectId);
                           }

                        } else { //Add new layer to hit layers array.
                           const handle = layerView.highlight(gra); //Highlight new feature.
                           hitLayers.Add({ layerName: layerName, objectId: objectId, handle: handle, active: true });
                           //Util.errMsg("Added hitLayer Name OID HitLayers: " + layerName + " " + objectId, hitLayers);
                        }
                     });
                  }
               }
            } //end if the graphic is a feature layer graphic
         } //end for all graphic results.

         setTimeout(function () { clearHitLayers(); }, 50); //Delay is required because of whenLayerView promise.

         if (!graFound) {
            MainMap.activeViewDiv.style.cursor = "default";
         }
      }); //end hit test.
   } //end if active tool is select on map or identify.
} //end function.

//Clear inactive hitlayers.
function clearHitLayers(clearAll?: boolean) {
   for (const hitLayer of hitLayers) {
      if (clearAll) {
         hitLayer.active = false;
      }
      if (!hitLayer.active && hitLayer.objectId > -1) {
         //Util.errMsg("Clearing hitLayer: " + hitLayer.layerName + " " + hitLayer.objectId);

         hitLayer.objectId = -1;
         if (hitLayer.handle) {
            hitLayer.handle.remove(); //Unhighlight existing feature.
            hitLayer.handle = null;
         }
      }
   }
}

//Get hitlayer.
function getHitLayer(layerName: string): iHitLayer {
   for (const hitLayer of hitLayers) {
      if (hitLayer.layerName === layerName) {
         return hitLayer;
      }
   }
   return null;
}
